import { render, staticRenderFns } from "./curriculum-category.vue?vue&type=template&id=4634da14&scoped=true"
import script from "./curriculum-category.vue?vue&type=script&lang=js"
export * from "./curriculum-category.vue?vue&type=script&lang=js"
import style0 from "./curriculum-category.vue?vue&type=style&index=0&id=4634da14&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634da14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4634da14')) {
      api.createRecord('4634da14', component.options)
    } else {
      api.reload('4634da14', component.options)
    }
    module.hot.accept("./curriculum-category.vue?vue&type=template&id=4634da14&scoped=true", function () {
      api.rerender('4634da14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/curriculum-category.vue"
export default component.exports